import { render, staticRenderFns } from "./TextCellEditor.vue?vue&type=template&id=61e8c600&scoped=true"
import script from "./TextCellEditor.vue?vue&type=script&lang=js"
export * from "./TextCellEditor.vue?vue&type=script&lang=js"
import style0 from "./TextCellEditor.vue?vue&type=style&index=0&id=61e8c600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8c600",
  null
  
)

export default component.exports